import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  startISO: null,
  endISO: null,
  selectedLabels: [],
  page: 1,
  pageSize: 10,
};

const alarmsSearchSlice = createSlice({
  name: "alarmsSearch",
  initialState,
  reducers: {
    setAlarmsDateRange(state, action) {
      const { startISO, endISO } = action.payload || {};
      state.startISO = startISO ?? null;
      state.endISO = endISO ?? null;
    },
    setAlarmsSelectedLabels(state, action) {
      state.selectedLabels = action.payload || [];
    },
    setAlarmsCriteria(state, action) {
      const { startISO, endISO, selectedLabels } = action.payload || {};
      state.startISO = startISO ?? null;
      state.endISO = endISO ?? null;
      state.selectedLabels = Array.isArray(selectedLabels)
        ? selectedLabels
        : [];
    },
    setAlarmsPagination(state, action) {
      const { page, size } = action.payload || {};
      if (page !== undefined) state.page = page;
      if (size !== undefined) state.size = size;
    },
    resetAlarmsCriteria() {
      return initialState;
    },
  },
});

export const {
  setAlarmsDateRange,
  setAlarmsSelectedLabels,
  setAlarmsCriteria,
  setAlarmsPagination,
  resetAlarmsCriteria,
} = alarmsSearchSlice.actions;

export default alarmsSearchSlice.reducer;

export const selectAlarmsCriteria = (state) => state.alarmsSearch;
